import { DynamicContentBuilder } from 'modules/dynamicContentBuilder';
import { useModalContext } from 'utils/contexts/modal';
import { useInsertContent } from '../hooks';
import { Modal } from '../types/modal';
import { CreativeLibraryPanelModal } from './CreativeLibraryPanelModal';
import { MovableInkPanelModal } from './MovableInkPanelModal';
import { HtmlCleanupConfirmationModal } from './HtmlCleanupConfirmationModal';
import { HtmlDiffViewerModal } from './HtmlDiffViewerModal';
import { SnippetSelectorModal } from './SnippetSelectorModal';

export const WYSIWYGModals = () => {
  const { modalState, hideModal } = useModalContext<Modal>();
  const insertContent = useInsertContent();

  const insertContentAndHideModal = (content: string) => {
    insertContent(content);
    hideModal();
  };

  switch (modalState) {
    case Modal.CreativeLibrary:
      return <CreativeLibraryPanelModal />;
    case Modal.MovableInk:
      return <MovableInkPanelModal />;
    case Modal.SnippetSelector:
      return <SnippetSelectorModal />;
    case Modal.ConfirmCleanup:
      return <HtmlCleanupConfirmationModal />;
    case Modal.ViewChanges:
      return <HtmlDiffViewerModal />;
    case Modal.DynamicContentBuilder:
      return <DynamicContentBuilder onInsert={insertContentAndHideModal} onClose={hideModal} />;
    default:
      return null;
  }
};
